import React from 'react';
import Modal from '../../../../../Common/Components/Modal';
import { AdminSidebarDisableMfaUserProps } from '../../../../../types/AdminSidebarDisableMfaUserProps';
import { useAppContext } from '../../../../../utils/AppContext';
import { putRequestAll } from '../../../../../utils/fetch';
import { ReactComponent as WarningIcon } from '../../../../../img/icons/warning.svg';

function AdminSidebarDisableMfaUser(props: AdminSidebarDisableMfaUserProps): JSX.Element {
  const {
    setOpenModal,
    selectedUsers,
    setLoader } = props;

  const { addNotification } = useAppContext();

  return (
    <Modal
      setModalOpen={() => setOpenModal(0)}
      className="admin-user-modal"
      title="Disable MFA"
      primaryButtonAction={async () => {
        setOpenModal(0);
        setLoader();
        if (selectedUsers !== undefined) {
          try {
            const requests: { path: string, data: { email: string, name: string, phone: string, mfa: boolean }}[] = Array.from(selectedUsers.values()).map(
              (value) => ({
                path: `/organizations/${value.accountid}/users/${value.userid}?targetRole=${value.roles}`,
                data: { email: value.email,
                  name: value.name,
                  phone: value.phone,
                  mfa: false },
              }),
            );
            putRequestAll(requests)
              .then((results) => {
                if (results.resolved === requests.length) {
                  addNotification({ type: 'success', message: 'Multi-factor authentication will not be required for these user(s).' });
                } else {
                  addNotification({ type: 'error', message: 'Your "Disable MFA" operation has failed.' });
                }
              });
          } catch (e) {
            addNotification({ type: 'error', message: 'Your "Disable MFA" operation has failed.' });
          }
        }
      }}
      primaryButtonLabel="Apply"
      secondaryButtonAction={() => setOpenModal(0)}
      secondaryButtonLabel="Cancel"
      borderTopColor="yellow"
    >
      <div className="admin-user-modal-content">
        <WarningIcon className="admin-user-modal-content-icon" />
        Remove multi-factor authentication for these users?
      </div>
    </Modal>
  );
}

export default AdminSidebarDisableMfaUser;
